const replaceDomain = (url) => {
  // const oldDomain = "http://3.219.149.110:8080";
  try {
    const parsed = new URL(url);

    // If domain matches the old one, replace it
    // if (parsed.origin !== process.env.REACT_APP_API_URL) {
    //   return process.env.REACT_APP_API_URL + parsed.pathname;
    // }

    // Otherwise return original URL
    return url;

  } catch (_) {
    // If url is not absolute (e.g. relative path), return as-is
    return url;
  }
}

export default replaceDomain;